export default __webpack_public_path__ + "static/media/magnifying_glass.9cd8990e.svg";